import React, { useState, useCallback } from 'react';
import { useRetryableObservable } from 'react-use-observable';
import shoppingService from 'v2/services/shopping/product';

import type { ShoppingDelivery } from 'v2/interfaces/shopping';

import ProductList from './List';
import ProductQuickview from './Quickview';
import useStyle from './styles';

const Product = () => {
  const classes = useStyle();

  const [currentDelivery, setCurrentDelivery] = useState(null);
  const [open, setOpen] = useState<boolean>(false);

  const [, , , loadAgain] = useRetryableObservable(() => shoppingService.loadDeliveries(), []);

  const openQuickView = useCallback((shopping: ShoppingDelivery) => {
    setCurrentDelivery(shopping);
    setOpen(true);
  }, []);

  const closeQuickView = useCallback(
    (refetch?: boolean) => {
      setOpen(false);
      setCurrentDelivery(null);
      refetch && loadAgain();
    },
    [loadAgain]
  );

  return (
    <div id={'shopping-product'} className={classes.content}>
      <ProductList onClickRow={openQuickView} />
      <ProductQuickview open={open} onClose={closeQuickView} delivery={currentDelivery} closeQuickView={closeQuickView} />
    </div>
  );
};

export default Product;
